export const slugify = (name) =>
  name.toLowerCase().replace(/[()]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const SPECIES_CATALOG = [
  {
    name: "White Oak",
    latin: "Quercus alba",
    origin: "USA — Appalachian & Central",
    type: "Hardwood",
    tag: "Signature",
    note: "Dense, closed-grain and prized for cooperage, flooring and marine joinery. Our most requested export grade.",
    description:
      "White Oak is the benchmark North American hardwood — dense, durable and closed-grain, with a tyloses-filled heartwood that makes it naturally watertight and suitable for wine barrels and exterior use. Its long medullary rays produce a more pronounced figure than red oak, and structural testing confirms greater inherent fibre strength than European oak. With excellent steam-bending capability and superb finishing, it is the species of choice for cooperage, marine construction and premium flooring across European and Asian markets.",
    image: "https://images.pexels.com/photos/8337527/pexels-photo-8337527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
    gallery: [
      { src: "/species/white-oak-1.jpg", caption: "White Oak grain — export grade board" },
      { src: "/species/white-oak-2.jpg", caption: "Airport interior panelled in American White Oak" },
      { src: "/species/white-oak-3.jpg", caption: "Auditorium ceiling in White Oak" },
      { src: "/species/white-oak-4.jpg", caption: "White Oak glulam canopy structure" },
    ],
    grades: ["FAS", "FAS 1-Face", "Select & Better", "No.1 Common"],
    dimensions: ["4/4 (25mm)", "5/4 (32mm)", "6/4 (38mm)", "8/4 (50mm)"],
    properties: { color: "Light to mid brown", density: "≈ 769 kg/m³", hardness: "1,360 lbf (Janka)", workability: "Excellent" },
    uses: ["Cooperage", "Flooring", "Marine joinery", "Cabinetry", "Sliced veneer"],
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    name: "Black Walnut",
    latin: "Juglans nigra",
    origin: "USA — Midwest & Central",
    type: "Hardwood",
    tag: "Premium",
    note: "Rich chocolate heartwood, exceptional for fine furniture and architectural millwork.",
    description:
      "American Black Walnut is one of the world's most coveted furniture woods, its light-brown to dark chocolate heartwood contrasting sharply with creamy sapwood — occasionally with striking wavy or curly figure sought after by designers. Rated as one of the most decay-resistant American hardwoods, it works easily by hand or machine and polishes to an excellent finish. Offered steamed for colour uniformity or unsteamed for maximum contrast, it is a staple of high-end furniture, gunstocks and architectural interiors.",
    image: "https://images.pexels.com/photos/8251472/pexels-photo-8251472.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
    gallery: [
      { src: "/species/black-walnut-1.jpg", caption: "Black Walnut grain — export grade board" },
      { src: "/species/black-walnut-2.jpg", caption: "Theatre interior in American Walnut" },
      { src: "/species/black-walnut-3.jpg", caption: "Walnut sideboard — fine furniture" },
      { src: "/species/black-walnut-4.jpg", caption: "Walnut exterior planters & cladding" },
    ],
    grades: ["FAS", "FAS 1-Face", "No.1 Common", "Steamed / Unsteamed"],
    dimensions: ["4/4 (25mm)", "5/4 (32mm)", "6/4 (38mm)", "8/4 (50mm)"],
    properties: { color: "Chocolate brown heartwood", density: "≈ 609 kg/m³", hardness: "1,010 lbf (Janka)", workability: "Excellent" },
    uses: ["Fine furniture", "Gunstocks", "Architectural millwork", "Veneer"],
    span: "lg:col-span-5",
  },
  {
    name: "Hard Maple",
    latin: "Acer saccharum",
    origin: "USA / Canada — Great Lakes",
    type: "Hardwood",
    tag: "High Volume",
    note: "Bright, uniform and exceptionally hard. The benchmark for flooring and sports surfaces.",
    description:
      "Also known as Sugar Maple, Hard Maple is world-renowned for its delicate creamy colour, close fine texture and outstanding resistance to abrasion and wear. Highly prized 'curly', 'fiddleback' and 'birds eye' figure can occur, and white-selected stock (NHLA '1&2 white') delivers the most consistent colour available. It machines, turns and finishes beautifully, making it the standard for bowling alleys, sports floors, butcher block, worktops and high-traffic flooring.",
    image: "https://images.pexels.com/photos/12278585/pexels-photo-12278585.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
    gallery: [
      { src: "/species/hard-maple-1.jpg", caption: "Hard Maple grain — export grade board" },
      { src: "/species/hard-maple-2.jpg", caption: "Hard Maple dining furniture" },
      { src: "/species/hard-maple-3.jpg", caption: "Café interior fitted in Hard Maple" },
      { src: "/species/hard-maple-4.jpg", caption: "Concert hall lined in Maple" },
    ],
    grades: ["FAS", "Select", "No.1 Common", "Sap & Better"],
    dimensions: ["4/4 (25mm)", "5/4 (32mm)", "6/4 (38mm)", "8/4 (50mm)"],
    properties: { color: "Creamy white to pale", density: "≈ 705 kg/m³", hardness: "1,450 lbf (Janka)", workability: "Good" },
    uses: ["Flooring", "Sports surfaces", "Butcher block", "Cabinetry"],
    span: "lg:col-span-5",
  },
  {
    name: "Western Red Cedar",
    latin: "Thuja plicata",
    origin: "Canada — British Columbia",
    type: "Softwood",
    tag: "Canadian",
    note: "Naturally rot-resistant, aromatic and dimensionally stable for cladding and outdoor structures.",
    description:
      "Western Red Cedar is a Canadian icon — lightweight, aromatic and naturally resistant to decay and insects. Its dimensional stability and rich colour make it the premier choice for exterior cladding, decking, pergolas and saunas in every climate.",
    image: "https://images.pexels.com/photos/12278570/pexels-photo-12278570.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
    gallery: [
      { src: "/species/western-red-cedar-1.jpg", caption: "Western Red Cedar cladding" },
      { src: "/species/western-red-cedar-2.jpg", caption: "Cedar timber texture" },
    ],
    grades: ["Clear", "A & Better", "Knotty (STK)"],
    dimensions: ["1x dimensional", "2x dimensional", "Custom patterns"],
    properties: { color: "Reddish brown", density: "≈ 370 kg/m³", hardness: "350 lbf (Janka)", workability: "Excellent" },
    uses: ["Cladding & siding", "Decking", "Outdoor structures", "Joinery"],
    span: "lg:col-span-7",
  },
  {
    name: "Red Oak",
    latin: "Quercus rubra",
    origin: "USA — Northern & Appalachian",
    type: "Hardwood",
    tag: "Volume",
    note: "The workhorse American hardwood — open-grained, strong and widely specified worldwide.",
    description:
      "Red Oak is the dominant species of the U.S. hardwood forests — it takes just over one second of forest growth to replace a cubic metre of lumber. Straight-grained and coarse-textured with distinctive medullary-ray figure, it offers very good strength relative to weight, high crushing strength and excellent steam-bending capability. Hard, stable when dry and easy to stain and finish, it is specified globally for furniture, flooring, mouldings and interior joinery at consistent supply and excellent value.",
    image: "https://images.unsplash.com/photo-1621295693450-080546d2ec8e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: [
      { src: "/species/red-oak-1.jpg", caption: "Red Oak grain — export grade board" },
      { src: "/species/red-oak-2.jpg", caption: "Red Oak lounge furniture" },
      { src: "/species/red-oak-3.jpg", caption: "Sculpted interior in Red Oak" },
    ],
    grades: ["FAS", "FAS 1-Face", "Select & Better", "No.1 Common"],
    dimensions: ["4/4 (25mm)", "5/4 (32mm)", "6/4 (38mm)", "8/4 (50mm)"],
    properties: { color: "Pinkish to reddish brown", density: "≈ 705 kg/m³", hardness: "1,290 lbf (Janka)", workability: "Good" },
    uses: ["Furniture", "Flooring", "Mouldings", "Doors & joinery"],
  },
  {
    name: "American Cherry",
    latin: "Prunus serotina",
    origin: "USA — Appalachian",
    type: "Hardwood",
    tag: "Premium",
    note: "Warm reddish tones that deepen with age — a favourite for fine cabinetry.",
    description:
      "American Black Cherry is a supreme U.S. hardwood, unique to North America, with rich red to reddish-brown heartwood that darkens beautifully on exposure to light. Its fine, uniform, straight grain and smooth texture stain and polish to an exceptional surface, and boards can be supplied colour-sorted (e.g. 90/50 heartwood specifications). Grown principally in Pennsylvania, New York, Virginia and West Virginia, it is highly prized for fine furniture, cabinetry, interior joinery and panelling.",
    image: "https://images.unsplash.com/photo-1697507695420-04623ccff2af?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: [
      { src: "/species/american-cherry-1.jpg", caption: "American Cherry grain — export grade board" },
      { src: "/species/american-cherry-2.jpg", caption: "Cherry chair — studio craftsmanship" },
      { src: "/species/american-cherry-3.jpg", caption: "Cherry tables — fine furniture" },
      { src: "/species/american-cherry-4.jpg", caption: "Opera house auditorium in Cherry" },
    ],
    grades: ["FAS", "FAS 1-Face", "No.1 Common"],
    dimensions: ["4/4 (25mm)", "5/4 (32mm)", "6/4 (38mm)", "8/4 (50mm)"],
    properties: { color: "Warm reddish brown", density: "≈ 561 kg/m³", hardness: "950 lbf (Janka)", workability: "Excellent" },
    uses: ["Fine furniture", "Cabinetry", "Mouldings", "Panelling"],
  },
  {
    name: "White Ash",
    latin: "Fraxinus americana",
    origin: "USA — Eastern",
    type: "Hardwood",
    tag: "Volume",
    note: "Tough, shock-resistant and elastic — the wood of tool handles and sports gear.",
    description:
      "American Ash combines outstanding strength-to-weight with excellent shock resistance — which is why it has always been the wood of baseball bats, hockey sticks and tool handles. Its strong grain contrast between soft summer and hard winter growth means no two boards are ever alike, and it steam-bends superbly, making it a favourite of furniture makers. Hard, stable when dry and easy to finish, it is equally at home in light-toned furniture, flooring and interior architecture.",
    image: "https://images.unsplash.com/photo-1583418007992-a8e33a92e7ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: [
      { src: "/species/white-ash-1.jpg", caption: "White Ash grain — export grade board" },
      { src: "/species/white-ash-2.jpg", caption: "Ash slat wall — lecture room" },
      { src: "/species/white-ash-3.jpg", caption: "Ash rooftop terrace decking" },
      { src: "/species/white-ash-4.jpg", caption: "Ash cladding battens" },
    ],
    grades: ["FAS", "Select & Better", "No.1 Common"],
    dimensions: ["4/4 (25mm)", "5/4 (32mm)", "6/4 (38mm)", "8/4 (50mm)"],
    properties: { color: "Pale, light brown", density: "≈ 673 kg/m³", hardness: "1,320 lbf (Janka)", workability: "Good" },
    uses: ["Tool handles", "Sports equipment", "Flooring", "Furniture"],
  },
  {
    name: "Yellow Poplar",
    latin: "Liriodendron tulipifera",
    origin: "USA — Eastern",
    type: "Hardwood",
    tag: "Utility",
    note: "Stable, fine-textured and paint-friendly — a versatile industrial hardwood.",
    description:
      "Yellow Poplar — known in export markets as American Tulipwood — is one of the most prolific U.S. hardwoods and unique to North America. It has extraordinary strength relative to its weight, making it increasingly popular for structural uses such as glulam beams and cross-laminated timber (CLT), including landmark projects like The Smile pavilion in London. Straight-grained, fine-textured and extremely stable when dry, it machines cleanly, takes paint exceptionally well, and comes in wider, longer boards than most species.",
    image: "https://images.pexels.com/photos/5497868/pexels-photo-5497868.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
    gallery: [
      { src: "/species/yellow-poplar-1.jpg", caption: "Tulipwood grain — export grade board" },
      { src: "/species/yellow-poplar-2.jpg", caption: "Tulipwood reception counter" },
      { src: "/species/yellow-poplar-3.jpg", caption: "Tulipwood CLT panel production" },
      { src: "/species/yellow-poplar-4.jpg", caption: "The Smile pavilion — Tulipwood CLT" },
    ],
    grades: ["FAS", "Select & Better", "No.1 Common"],
    dimensions: ["4/4 (25mm)", "5/4 (32mm)", "6/4 (38mm)", "8/4 (50mm)", "up to 16/4"],
    properties: { color: "Pale yellow to olive", density: "≈ 449 kg/m³", hardness: "540 lbf (Janka)", workability: "Excellent" },
    uses: ["Mouldings", "Cabinet frames", "Paint-grade joinery", "Glulam & CLT", "Plywood core"],
  },
  {
    name: "Douglas Fir",
    latin: "Pseudotsuga menziesii",
    origin: "USA / Canada — Pacific Northwest",
    type: "Softwood",
    tag: "Structural",
    note: "High strength-to-weight ratio — the premier structural softwood of the West.",
    description:
      "Douglas Fir offers an outstanding strength-to-weight ratio and is the go-to structural softwood for beams, heavy timbers and framing. Its straight grain and warm colour also suit exposed joinery and flooring.",
    image: "https://images.pexels.com/photos/12142000/pexels-photo-12142000.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
    gallery: [
      { src: "/species/douglas-fir-1.jpg", caption: "Douglas Fir timber stack" },
    ],
    grades: ["Clear", "Select Structural", "No.1 & No.2"],
    dimensions: ["Dimensional lumber", "Heavy timbers", "Custom sizes"],
    properties: { color: "Light reddish brown", density: "≈ 530 kg/m³", hardness: "660 lbf (Janka)", workability: "Good" },
    uses: ["Structural timber", "Beams", "Joinery", "Flooring"],
  },
  {
    name: "Southern Yellow Pine",
    latin: "Pinus spp.",
    origin: "USA — Southeast",
    type: "Softwood",
    tag: "Construction",
    note: "Strong, resinous and highly treatable — the backbone of construction lumber.",
    description:
      "Southern Yellow Pine is the strongest softwood group in North America, grown across the U.S. Southeast and prized worldwide for construction. Dense and resinous with high bending strength, it accepts pressure treatment better than almost any other softwood, making it the standard for decking, marine structures and treated applications. Kiln-dried, heat-treated (KD-HT) and grade-stamped stock ships export-ready for framing, decking, pallets and industrial uses.",
    image: "https://images.unsplash.com/photo-1681752972950-6229ca099fbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: [
      { src: "/species/southern-yellow-pine-1.jpg", caption: "Graded Southern Pine dimension lumber" },
      { src: "/species/southern-yellow-pine-2.jpg", caption: "Southern Pine decking boards" },
      { src: "/species/southern-yellow-pine-3.jpg", caption: "Longleaf pine — Southern U.S. forests" },
      { src: "/species/southern-yellow-pine-4.jpg", caption: "Southern Pine needles — sustainable forestry" },
    ],
    grades: ["No.1", "No.2", "KD-HT", "Structural"],
    dimensions: ["Dimensional lumber", "Timbers", "Custom sizes"],
    properties: { color: "Yellowish to reddish", density: "≈ 640 kg/m³", hardness: "870 lbf (Janka)", workability: "Good" },
    uses: ["Construction", "Decking", "Pallets", "Treated lumber"],
  },
  {
    name: "Spruce-Pine-Fir (SPF)",
    latin: "Picea / Pinus / Abies",
    origin: "Canada — Boreal",
    type: "Softwood",
    tag: "Canadian",
    note: "Light, bright and consistent — Canada's premier framing lumber group.",
    description:
      "SPF is a Canadian softwood group prized for its light weight, bright colour and consistent, knot-free framing grades. J-Grade and MSR options serve demanding framing and packaging markets worldwide.",
    image: "https://images.unsplash.com/photo-1634672652995-ee7525bce595?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: [
      { src: "/species/spruce-pine-fir-spf-1.jpg", caption: "SPF framing lumber" },
    ],
    grades: ["J-Grade", "No.2 & Better", "MSR"],
    dimensions: ["Dimensional lumber", "Custom sizes"],
    properties: { color: "Bright, pale", density: "≈ 420 kg/m³", hardness: "510 lbf (Janka)", workability: "Excellent" },
    uses: ["Framing", "Construction", "Packaging"],
  },
  {
    name: "Eastern White Pine",
    latin: "Pinus strobus",
    origin: "USA / Canada — Northeast",
    type: "Softwood",
    tag: "Heritage",
    note: "Soft, stable and easy to work — a classic for panelling and mouldings.",
    description:
      "Eastern White Pine is a soft, stable and easily worked softwood with a fine, even texture. It has been a New England staple for centuries, used for panelling, mouldings, furniture and traditional joinery.",
    image: "https://images.unsplash.com/photo-1564512533667-015a90133f04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: [
      { src: "/species/eastern-white-pine-1.jpg", caption: "White Pine panelling" },
    ],
    grades: ["C Select", "D Select", "Premium", "Standard"],
    dimensions: ["4/4 – 8/4", "Patterns", "Custom sizes"],
    properties: { color: "Creamy white to straw", density: "≈ 390 kg/m³", hardness: "380 lbf (Janka)", workability: "Excellent" },
    uses: ["Panelling", "Mouldings", "Furniture", "Joinery"],
  },
].map((s) => ({ ...s, slug: slugify(s.name) }));

export const getSpecies = (slug) => SPECIES_CATALOG.find((s) => s.slug === slug);

// Featured cards for the home "Tetris" grid
export const SPECIES = SPECIES_CATALOG.slice(0, 4);

export const SPECIES_INDEX = {
  Hardwoods: SPECIES_CATALOG.filter((s) => s.type === "Hardwood"),
  Softwoods: SPECIES_CATALOG.filter((s) => s.type === "Softwood"),
};

// Export markets — standard global markets with approx. positions (%) over the world map image
export const MARKETS = [
  { region: "North America", port: "Savannah, USA", x: 25.5, y: 41, origin: true },
  { region: "Europe", port: "Rotterdam, NL", x: 48.5, y: 30 },
  { region: "North Africa", port: "Alexandria, EG", x: 54.5, y: 43 },
  { region: "Middle East", port: "Jebel Ali, UAE", x: 61.5, y: 45 },
  { region: "South Asia", port: "Nhava Sheva, IN", x: 68, y: 48 },
  { region: "Southeast Asia", port: "Ho Chi Minh, VN", x: 76.5, y: 52 },
  { region: "East Asia", port: "Shanghai, CN", x: 80.5, y: 42 },
  { region: "South America", port: "Santos, BR", x: 33, y: 68 },
];
